import { schema } from "normalizr";

const file = new schema.Entity(`files`);
const arrayOfFiles = [file];

export { file, arrayOfFiles };
